import App from './App.svelte';
import './services/bootstrap.js';

const app = new App({
	target: document.body,
});

export default app;
